import { render, staticRenderFns } from "./DownLoading.vue?vue&type=template&id=da84bbe4&scoped=true&"
import script from "./DownLoading.vue?vue&type=script&lang=js&"
export * from "./DownLoading.vue?vue&type=script&lang=js&"
import style0 from "./DownLoading.vue?vue&type=style&index=0&id=da84bbe4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da84bbe4",
  null
  
)

export default component.exports